/**
 * WebHID 设备实现
 * 直接与浏览器 WebHID API 交互
 */
import { getDeviceFilters } from '../config/keyboardDevices.js'
import { findOuterIndexByReportId } from './index.js'

export class WebHIDDevice {
  constructor() {
    this.device = null
    this.productName = ''
    this.vendorId = null
    this.productId = null
    this.oninputreport = null
    this.onlanguagechange = null
    this.isOpened = false
  }

  /**
   * 请求用户选择设备
   * @returns {Promise<boolean>}
   */
  async connect() {
    try {
      console.log('[WebHID] 请求设备连接...')
      const devices = await navigator.hid.requestDevice({
        filters: getDeviceFilters()
      })

      if (devices && devices.length > 0) {
        // 打印设备信息
        devices.forEach((dev, idx) => {
          console.log(`设备 ${idx}:`, {
            productId: dev.productId,
            vendorId: dev.vendorId,
            productName: dev.productName
          })
        })

        const index = findOuterIndexByReportId(devices, 4)
        if (index === -1) {
          throw new Error('未找到支持的设备（reportId=4）')
        }

        this.device = devices[index]
        this.productName = this.device.productName || 'Unknown Device'
        this.vendorId = this.device.vendorId
        this.productId = this.device.productId

        console.log('[WebHID] 找到设备:', this.productName)
        return true
      }

      console.warn('[WebHID] 用户未选择设备')
      return false
    } catch (error) {
      console.error('[WebHID] 连接失败:', error)
      throw error
    }
  }

  /**
   * 打开设备连接
   * @returns {Promise<void>}
   */
  async open() {
    if (!this.device) {
      throw new Error('[WebHID] 设备未连接，请先调用 connect()')
    }

    try {
      await this.device.open()
      this.isOpened = true

      // 设置数据接收回调
      this.device.oninputreport = (event) => {
        if (this.oninputreport) {
          this.oninputreport(event)
        }
      }

      console.log('[WebHID] 设备已打开')
    } catch (error) {
      console.error('[WebHID] 打开设备失败:', error)
      throw error
    }
  }

  /**
   * 发送数据到设备
   * @param {number} reportId - Report ID
   * @param {Uint8Array} data - 数据
   * @returns {Promise<void>}
   */
  async sendReport(reportId, data) {
    if (!this.device) {
      throw new Error('[WebHID] 设备未连接')
    }

    if (!this.isOpened) {
      throw new Error('[WebHID] 设备未打开')
    }

    try {
      await this.device.sendReport(reportId, data)
    } catch (error) {
      console.error('[WebHID] 发送数据失败:', error)
      throw error
    }
  }

  /**
   * 关闭设备连接
   * @returns {Promise<void>}
   */
  async close() {
    if (this.device && this.isOpened) {
      try {
        await this.device.close()
        this.isOpened = false
        console.log('[WebHID] 设备已关闭')
      } catch (error) {
        console.error('[WebHID] 关闭设备失败:', error)
      }
    }
  }

  /**
   * 获取设备信息
   * @returns {Object}
   */
  getDeviceInfo() {
    return {
      productName: this.productName,
      vendorId: this.vendorId,
      productId: this.productId,
      isOpened: this.isOpened
    }
  }
}
